import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DetailPhysicalAddress, SuggestedPhysicalAddress } from '@rd/types';
import { Observable } from 'rxjs';
import {
  LoadDetailAddress,
  LoadSuggestedAddresses,
  UpdateDetailAddress,
} from '../../store/actions/physical-address.actions';
import {
  getDetailAddress,
  getDetailAddressLoading,
  getSuggestedAddresses,
  getSuggestedAddressesLoading,
} from '../../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class PhysicalAddressFacade {
  suggestedAddressLoading$: Observable<boolean> = this.store.select(
    getSuggestedAddressesLoading,
  );

  suggestedAddresses$: Observable<SuggestedPhysicalAddress[]> =
    this.store.select(getSuggestedAddresses);

  detailAddressLoading$: Observable<boolean> = this.store.select(
    getDetailAddressLoading,
  );
  detailAddress$: Observable<DetailPhysicalAddress | null> =
    this.store.select(getDetailAddress);

  constructor(private store: Store) {}

  querySuggestedAddresses(query: string): void {
    this.store.dispatch(new LoadSuggestedAddresses({ query }));
  }

  queryDetailAddress(id: string): void {
    this.store.dispatch(new LoadDetailAddress({ id }));
  }

  updateDetailAddress(address: DetailPhysicalAddress): void {
    this.store.dispatch(new UpdateDetailAddress(address));
  }
}
